<template>
	<el-dialog :visible.sync="visible" width="800px" class="sell-type-model" custom-class="sell-type-model1"
		destroy-on-close @closed="closed">

		<div class="index_header">
			<div class="title_top">
				<div class="title_top_content"><img
						src="https://oss.pzds.com/mobileV3/ac295f1a6fe3301d7f2a4a78fed04d5a.png"
						class="title_top_content_icon"> <span class="title_top_content_text">易号代售为您的交易保驾护航</span></div> <span
					class="title_top_number"></span>
			</div>
			<div class="flex index_bar">
				<div class="index_tab tab-item_0" :class="{'index_active':active == 0}" @click="active = 0"><span
						class="text">寄售指南</span>
				</div>
				<div class="index_tab tab-item_1" :class="{'index_active':active == 1}" @click="active = 1"><span
						class="text">回收指南</span>
				</div>
				<div class="index_tab-active index_tab-active_sell" v-if="active == 0"></div>
				<div class="index_tab-active index_tab-active_recovery" v-if="active == 1"></div>
			</div>
		</div>


		<div class="content">
			<div class="tab-box index_tab-active_recovery" v-if="active == 1">
				<div class="icon-box">
					<div class="icon-box_title">
						<div class="icon-box_title_item">
							
							
							
							<img
								src="https://oss.pzds.com/mobileV3/33fbc73a665d1c4ce3638292c257fca7.png" alt=""
								class="icon"> <span class="text">号商合作</span></div>
						<div class="icon-box_title_item"><img
								src="https://oss.pzds.com/mobileV3/33fbc73a665d1c4ce3638292c257fca7.png" alt=""
								class="icon"> <span class="text">变现快，估值高</span></div>
						<div class="icon-box_title_item"><img
								src="https://oss.pzds.com/mobileV3/33fbc73a665d1c4ce3638292c257fca7.png" alt=""
								class="icon"> <span class="text">急速成交</span></div>
					</div>
					<div class="process-box">
						<div class="process-item">
							
							<img class="icon" 
							:src="require(`@/assets/image/sell_ic1.png`)">
							<div class="text">填写商品信息</div>
						</div>
						<div class="process-item">	<img class="icon" 
							:src="require(`@/assets/image/sell_ic2.png`)">
							<div class="text">联系客服回收</div>
						</div>
						<div class="process-item">	<img class="icon" 
							:src="require(`@/assets/image/sell_ic3.png`)">
							<div class="text">买家下单支付</div>
						</div>
						<div class="process-item">	<img class="icon" 
							:src="require(`@/assets/image/sell_ic4.png`)">
							<div class="text">客服协助交易</div>
						</div>
					</div>
				</div>

				<div class="button-box">
					
					<a href="https://tb.53kf.com/code/client/dbcf39efd2c649334d9816205b768c0e3/1" target="_blank" class="button-box_button">
						立即回收
					</a>
					
					</div>
			</div>
			<div class="tab-box index_tab-active_sell" v-if="active == 0">
				<div class="icon-box">
					<div class="icon-box_title">
						<div class="icon-box_title_item"><img
								src="https://oss.pzds.com/mobileV3/33fbc73a665d1c4ce3638292c257fca7.png" alt=""
								class="icon"> <span class="text">专属客服</span></div>
						<div class="icon-box_title_item"><img
								src="https://oss.pzds.com/mobileV3/33fbc73a665d1c4ce3638292c257fca7.png" alt=""
								class="icon"> <span class="text">售价高，有保障</span></div>
						<div class="icon-box_title_item"><img
								src="https://oss.pzds.com/mobileV3/33fbc73a665d1c4ce3638292c257fca7.png" alt=""
								class="icon"> <span class="text">平台曝光</span></div>
					</div>
					<div class="process-box">
						<div class="process-item">	<img class="icon" 
							:src="require(`@/assets/image/sell_ic1.png`)">
							<div class="text">填写商品信息</div>
						</div>
						<div class="process-item">	<img class="icon" 
							:src="require(`@/assets/image/sell_ic2.png`)">
							<div class="text">联系客服上架</div>
						</div>
						<div class="process-item">	<img class="icon" 
							:src="require(`@/assets/image/sell_ic3.png`)">
							<div class="text">买家下单支付</div>
						</div>
						<div class="process-item">	<img class="icon" 
							:src="require(`@/assets/image/sell_ic4.png`)">
							<div class="text">客服协助交易</div>
						</div>
					</div>
				</div>

				<div class="button-box"><button class="button-box_button" @click="gochushou">立即出售</button></div>
			</div>
		</div>
	</el-dialog>
</template>
<script>
	export default {
		props: {},
		components: {},
		data() {
			return {
				logined: Boolean(localStorage.getItem('usertoken')),
				visible: false,
				active: 0,


				list: [],
				vip: 0,

			}
		},
		computed: {

			isMobile() {
				return this.$store.getters.isMobile
			},
			lang() {
				return this.$store.getters.lang
			},
			darken() {
				return this.$store.getters.darken
			},
			grade() {
				let grade = {}
				for (let i in this.grades) {
					grade[Number(i) + 1] = this.grades[i]
				}
				return grade
			},


		},
		watch: {
			visible(v) {
				if (v) {

				} else {
					this.$router.replace(this.$route.path)
				}
			},

		},
		created() {

		},
		methods: {
			gochushou() {
				this.visible = false
				this.$router.push('/chushou')
			},
			closed() {
				this.visible = false
			},




		},
	}
</script>

<style>
	.sell-type-model1 {
		border-radius: 10px 10px 0 0;
		overflow: hidden;
	}

	.sell-type-model .el-dialog {
		background-color: transparent !important
	}

	.sell-type-model .el-dialog .el-dialog__header {
		padding: 0
	}

	.sell-type-model .el-dialog .el-dialog__header .el-dialog__headerbtn {
		right: 10px;
		top: 10px
	}

	.sell-type-model .el-dialog .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
		color: #fff;
		font-size: 32px
	}

	.sell-type-model {
		display: flex;
		flex-direction: column
	}

	.sell-type-model .index_header {
		background-color: #f4f4f4;
		border-top-left-radius: 16px;
		border-top-right-radius: 16px;
		height: 136px;
		position: relative
	}

	.sell-type-model .index_header .title_top {
		align-items: center;
		background:url(../../assets/image/sell_bk.png);
	
		background-repeat: no-repeat;
		background-size: cover;
		display: flex;
		height: 80px;
		padding-left: 158px
	}

	.sell-type-model .index_header .title_top_content {
		align-items: center;
		display: flex;
		margin-right: 8px
	}

	.sell-type-model .index_header .title_top_content_icon {
		height: 21px;
		margin-right: 2px;
		width: 20px
	}

	.sell-type-model .index_header .title_top_content_text {
		color: #fff;
		font-size: 16px;
		font-weight: 500
	}

	.sell-type-model .index_header .title_top_number {
		color: #fff;
		font-size: 20px;
		font-weight: 500;
		margin-bottom: 3px
	}

	.sell-type-model .index_header .index_bar {
		background-color: #ffaa56;
		bottom: 0;
		height: 56px;
		left: 0;
		line-height: 56px;
		position: absolute;
		width: 100%
	}

	.sell-type-model .index_header .index_bar:before {
		background-color: #f4f4f4;
		border-radius: 14px 14px 0 0;
		bottom: 0;
		content: "";
		height: 100%;
		position: absolute;
		width: 100%
	}

	.sell-type-model .index_header .index_bar .index_tab {
		align-items: flex-end;
		cursor: pointer;
		display: flex;
		flex: none;
		height: 100%;
		justify-content: center;
		position: relative;
		width: 50%
	}

	.sell-type-model .index_header .index_bar .index_tab .text {
		color: #666;
		font-size: 18px;
		z-index: 20
	}

	.sell-type-model .index_header .index_bar .index_tab+.index_tab-active {
		background-color: #fb6028;
		border-radius: 2px;
		bottom: 8px;
		height: 3px;
		position: absolute;
		transform: translateX(-50%);
		transition: all .3s ease-in-out;
		width: 24px;
		z-index: 10
	}

	.sell-type-model .index_header .index_bar .index_tab+.index_tab-active_sell {
		left: 25%
	}

	.sell-type-model .index_header .index_bar .index_tab+.index_tab-active_recovery {
		left: 75%
	}

	.sell-type-model .index_header .index_bar .index_tab.index_active .text {
		color: #333;
		font-size: 20px;
		font-weight: 700;
		height: auto
	}

	.sell-type-model .index_header .index_bar .index_tab.index_active:before {
		background-repeat: no-repeat;
		background-size: 100% auto;
		bottom: -1px;
		content: "";
		height: 65px;
		pointer-events: none;
		position: absolute;
		width: 426px;
		z-index: 9
	}

	.sell-type-model .index_header .index_bar .index_tab.index_active.tab-item_0:before {
		background-image: url(https://oss.pzds.com/mobileV3/808cb4f631292fea6507fe53c2cd5d41.png);
		left: 0
	}

	.sell-type-model .index_header .index_bar .index_tab.index_active.tab-item_1:before {
		background-image: url(https://oss.pzds.com/mobileV3/934e40517be22e8c1664504401514019.png);
		right: 0
	}

	.sell-type-model {
		background: transparent !important;
	}

	.sell-type-model .el-dialog .el-dialog__body {
		background: transparent;
		padding: 0;
	}

	.sell-type-model .el-dialog .el-dialog__body .content {
		background-color: #fff;
		padding: 16px 32px 32px
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box {
		border-radius: 8px
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .index_tab-active_recovery .process-box .text {
		line-height: 18px
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .icon-box {
		background: #fef7f0;
		border-radius: 12px;
		height: 220px;
		margin-bottom: 16px;
		padding: 14px 8px 8px;
		width: 100%
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .icon-box_title {
		align-items: center;
		display: flex;
		justify-content: center;
		margin-bottom: 14px
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .icon-box_title_item {
		align-items: center;
		display: flex;
		justify-content: center;
		margin-right: 24px
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .icon-box_title_item:last-child {
		margin-right: 0
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .icon-box_title_item .icon {
		height: 20px;
		margin-right: 2px;
		width: 20px
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .icon-box_title_item .text {
		color: #333;
		font-size: 16px;
		line-height: 20px
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .icon-box .process-box {
		align-items: center;
		background: #fff;
		border-radius: 8px;
		display: flex;
		height: 164px;
		padding: 16px 48px 24px
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .icon-box .process-box .process-item {
		align-items: center;
		display: flex;
		flex-direction: column;
		height: 124px;
		margin-right: 48px;
		padding-top: 12px;
		position: relative;
		width: 120px
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .icon-box .process-box .process-item:after {
		background: url(https://oss.pzds.com/mobileV3/73c8af4b8f74ce698f4cc85ec74ef448.png) no-repeat;
		background-size: 100% 100%;
		content: "";
		height: 24px;
		left: 132px;
		position: absolute;
		top: 40%;
		transform: translateY(-50%);
		width: 24px
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .icon-box .process-box .process-item:last-child {
		margin-right: 0
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .icon-box .process-box .process-item:last-child:after {
		content: normal
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .icon-box .process-box .process-item .icon {
		height: 64px;
		margin-bottom: 12px;
		width: 64px
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .icon-box .process-box .process-item .text {
		color: #333;
		font-size: 14px;
		font-weight: 400;
		line-height: 18px;
		text-align: center
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .tip-box {
		background: #f7f7f7;
		border-radius: 12px;
		margin: 16px 0;
		padding: 16px
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .tip-box_tip {
		color: #333;
		line-height: 20px;
		max-height: 300px;
		overflow-y: auto
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .button-box {
		align-items: center;
		display: flex;
		justify-content: center
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .button-box_button {
		background: #fb6028;
		border-radius: 12px;
		color: #fff;
		font-size: 16px;
		font-weight: 500;
		height: 50px;
		line-height: 50px;
		padding: 0;
		text-align: center;
		width: 240px
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .button-box_button:hover {
		opacity: .9
	}

	.sell-type-model .el-dialog .el-dialog__body .content .tab-box .button-box_button:active {
		transform: scale(.99)
	}

	.blackDay_model-box {
		align-items: center;
		display: flex;
		font-size: 18px;
		justify-content: center
	}

	.blackDay_model .el-dialog .el-dialog__header {
		color: #fff;
		padding: 20px
	}

	.blackDay_model .el-dialog .el-dialog__header .el-dialog__title {
		color: #fff
	}

	.blackDay_model .el-dialog .btn {
		border-radius: 5px;
		box-shadow: 0 8px 18px 0 rgba(72, 124, 247, .2);
		font-size: 20px;
		height: 50px;
		line-height: 50px;
		text-align: center;
		width: 200px
	}

	.blackDay_model .el-dialog .el-dialog__headerbtn .el-dialog__close {
		color: #fff
	}

	.quick-sell-content p {
		color: #666;
		font-size: 12px;
		font-weight: 400;
		line-height: 20px
	}

	.quick-sell-content p>strong {
		color: #333;
		display: inline-block;
		font-size: 12px;
		font-weight: 600;
		margin-top: 12px
	}
</style>